// -------------------------------------------
// INACTIVE("Inactive", 1),
// AWAITING_ACCEPT_INVITATION("Awaiting Accept Invitation", 2),
// LACK_OF_PERMISSIONS("Lack of Permissions", 3),
// ACTIVE("Active", 4);

// seller状态映射
export const SallerStatus = {
  Inactive: 1,
  "Awaiting Invitation Acceptance": 2,
  "Lack of Permissions": 3,
  Active: 4,
  Disconnected: 900, // 900 枚举值后端没有,通过接口字段 tokenDataIsActive 来定义, tokenDataIsActive: false 代表没有连接seller
} as const;

// seller状态反向映射
export const SallerStatusReverse = {
  [SallerStatus.Inactive]: "Inactive",
  [SallerStatus["Awaiting Invitation Acceptance"]]: "Awaiting Invitation Acceptance",
  [SallerStatus["Lack of Permissions"]]: "Lack of Permissions",
  [SallerStatus.Active]: "Active",
  [SallerStatus.Disconnected]: "Disconnected",
} as const;

// 获取数值类型
export type ISellerStatusValue = (typeof SallerStatus)[keyof typeof SallerStatus]; // 1 | 2 | 3 | 4 | 900

// 获取属性名类型
export type ISellerStatusName = keyof typeof SallerStatus; // "Inactive" | "Awaiting Invitation Acceptance" | "Lack of Permissions" | "Active" | "Disconnected"

// -------------------------------------------
// inboundAction 状态
// 未开启inbound服务 引导开启
// RRM_INTEGRATION_TIPS(1, "show RRM integration tips"),
// trackingId未填写完全 引导填写
// PENDING_TRACKING_ID_TIPS(2, "show pending tracking id tips"),
// packingList未生成 等待生成
// WAITING_PACKING_LIST_TIPS(3, "show waiting packing list tips"),
// 未确认
// CONFIRM(4, "confirm"),
// 已确认
// CONFIRMED(5, "confirmed"),
// 未上传
// UPLOAD(6, "upload"),
// 已上传
// UPLOADED(7, "uploaded"),
// 首次开case 选择不上传 自动
// NOT_UPLOAD(8, "not upload"),
// 首次开case 选择不上传并确认 手动
// NOT_UPLOAD_BUT_CONFIRM(9, "not upload but confirm"),
// 展示AWD标签
// 未知...

export enum InboundAction {
  // showConfirmClaim = -1, // 测试代码
  showRRMIntegrationTips = 1,
  showPendingTrackingIdTips = 2,
  showWaitingPackingListTips = 3,
  confirm = 4,
  confirmed = 5,
  upload = 6,
  uploaded = 7,
  notUpload = 8,
  notUploadButConfirm = 9,
  showAWDTips = 10,
}

// 上传渠道枚举
export enum UploadChannel {
  claimInboundSingle = "claim_inbound_single",
  documentCenterSingle = "document_center_single",
  documentCenterBatch = "document_center_batch",
}

// 上传操作类型枚举（uploadSingleFile 使用 1、2；0 仅用于 /inbound-case/manage/confirm 的 operation）
export enum UploadOperation {
  confirmManageNoUserUploadedFiles = 0, // manage/confirm 专用：拉取 currentFiles 后，列表中无用户上传文件（仅 system 或无文件）
  uploadAndConfirm = 1, // upload and confirm
  uploadAsDraft = 2, // upload as draft
}
